module.exports = __webpack_public_path__ + "img/img-13.28e69adc.png";